import { z } from 'zod'

export const ProductFormSchema = z.object({
  name: z.string().min(1, {
    message: 'catalog.products.form.name.required',
  }),
  mainCategoryId: z.string().min(1, {
    message: 'catalog.products.form.mainCategoryId.required',
  }),
  description: z.string().nullable().optional(),
  secondaryCategoryIds: z.array(z.string()).optional(),
  externalId: z.string().nullable().optional(),
  isActive: z.boolean().optional().default(true),
  productType: z.enum(['physical', 'virtual', 'service', 'package'], {
    required_error: 'catalog.products.form.productType.required',
  }),
  packageItems: z.array(
    z.object({
      productId: z.string().min(1),
      quantity: z.number().positive(),
    })
  ).optional(),
  variantAxisIds: z.array(z.string()).optional(),
  parameters: z.array(
    z.object({
      parameterId: z.string(),
      isRequired: z.boolean(),
      parameterValueId: z.string().nullable(),
      rawValue: z.string().nullable(),
    })
  ).optional(),
})

export type ProductFormValues = z.infer<typeof ProductFormSchema>

